module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/4/5-67f2adebd51f7a0311e0332cfc7aab52.jpg";